module.exports = __webpack_public_path__ + "img/growthimage-min.e361b703.png";